import { Button, Container, FormInput, Grid } from '@aurecon-creative-technologies/styleguide'
import { FC, useEffect, useState } from 'react'

import { gisAdd, gisDelete, gisLayer, gisQuery, gisUpdate } from '../api/GISAPI'
import Page from '../components/Page'
import Style from '../styles/AddProjectPage.module.sass'
import { ARCGIS_INSPECTION_COMMS_LAYER, ARCGIS_SW_LAND_LOT_COVERAGE_LAYER } from '../domain'

const GIS: FC = () => {
  const [property_number, property_numberSet] = useState('4000001')

  const [layerQuery, layerQuerySet] = useState<string>('---')
  const [objectid, objectidSet] = useState<string>('')

  const [sourceobjectid, sourceobjectidSet] = useState<string>('')

  const [spatial_reference, spatial_referenceSet] = useState<string>('4326')

  // eslint-disable-next-line
  const [data, dataSet] = useState<any>({})

  useEffect(() => {
    if (layerQuery === ARCGIS_INSPECTION_COMMS_LAYER) {
      if (data && data[0]?.attributes?.property_number) {
        const oi = data[0].attributes.OBJECTID ? data[0].attributes.OBJECTID : data[0].attributes.objectid
        sourceobjectidSet(oi)
      }
    }
  }, [data, layerQuery])

  useEffect(() => {
    if (layerQuery === ARCGIS_SW_LAND_LOT_COVERAGE_LAYER) {
      if (data && data[0]?.attributes?.property_number) {
        const oi = data[0].attributes.objectid ? data[0].attributes.objectid : data[0].attributes.OBJECTID
        objectidSet(oi)
      }
    }
  }, [data, layerQuery])

  const handleQueryCommsLayer = async () => {
    const response = await gisLayer({ layer: ARCGIS_INSPECTION_COMMS_LAYER })
    dataSet(response?.data?.featurelayer)
  }
  const handleQueryLandLotLayer = async () => {
    const response = await gisLayer({ layer: ARCGIS_SW_LAND_LOT_COVERAGE_LAYER })
    dataSet(response?.data?.featurelayer)
  }

  const handleQueryComms = async () => {
    layerQuerySet(ARCGIS_INSPECTION_COMMS_LAYER)
    const response = await gisQuery({ layer: ARCGIS_INSPECTION_COMMS_LAYER, property_number, spatial_reference })
    dataSet(response?.data?.feature)
  }

  const handleQueryLandLot = async () => {
    layerQuerySet(ARCGIS_SW_LAND_LOT_COVERAGE_LAYER)
    const response = await gisQuery({ layer: ARCGIS_SW_LAND_LOT_COVERAGE_LAYER, property_number, spatial_reference })
    dataSet(response?.data?.feature)
  }

  const handleUpdateComms = async () => {
    await gisUpdate({ layer: ARCGIS_INSPECTION_COMMS_LAYER, objectid: sourceobjectid })
  }

  const handleUpdateLand = async () => {
    await gisUpdate({ layer: ARCGIS_SW_LAND_LOT_COVERAGE_LAYER })
  }

  const handleAddComms = async () => {
    await gisAdd({ layer: ARCGIS_INSPECTION_COMMS_LAYER, property_number })
  }

  const handleDeleteComms = async () => {
    await gisDelete({ layer: ARCGIS_INSPECTION_COMMS_LAYER, objectid: sourceobjectid })
  }

  const handlePropChange = (v: string) => {
    property_numberSet(v)
  }

  return (
    <Page footer>
      <Container cssClass={Style.pageWrapper}>
        <Grid cssClass={Style.body}>
          <Grid item cssClass={Style.content} xs={3} md={3}>
            <FormInput
              label={'Property Number'}
              placeholder='4000001'
              // placeholder='4000001'
              value={property_number}
              default
              onChange={handlePropChange}
              type={'text'}
            />
          </Grid>
          <Grid item cssClass={Style.content} xs={3} md={3}>
            <FormInput
              label={'Source Object ID'}
              placeholder='Source Object ID'
              value={sourceobjectid}
              default
              onChange={sourceobjectidSet}
              type={'text'}
            />
          </Grid>
          <Grid item cssClass={Style.content} xs={3} md={3}>
            <FormInput
              label={'Object ID'}
              placeholder='Object ID'
              value={objectid}
              default
              onChange={objectidSet}
              type={'text'}
            />
          </Grid>

          <Grid item cssClass={Style.content} xs={3} md={3}>
            <FormInput
              label={'Spatial Reference WKID'}
              placeholder='4326'
              value={spatial_reference}
              default
              onChange={spatial_referenceSet}
              type={'text'}
            />
          </Grid>
          <Grid item cssClass={Style.content} xs={3} md={3}>
            <Button label='Query Comms Layer' onClick={handleQueryCommsLayer} />
            <Button label='Query Land Lot Layer' onClick={handleQueryLandLotLayer} />
          </Grid>
          <Grid item cssClass={Style.content} xs={3} md={3}>
            <Button label='Query Comms' onClick={handleQueryComms} />
            <Button label='Query Land Lot' onClick={handleQueryLandLot} />
          </Grid>
          <Grid item cssClass={Style.content} xs={3} md={3}>
            <Button label='Update Comms' onClick={handleUpdateComms} />
            <Button label='Update Land Lot' onClick={handleUpdateLand} />
          </Grid>
          <Grid item cssClass={Style.content} xs={3} md={3}>
            <Button label='Add Comms' onClick={handleAddComms} />
            <Button label='Delete Comms' onClick={handleDeleteComms} />
          </Grid>
          <Grid item cssClass={Style.content} xs={12} md={12}>
            <pre>{JSON.stringify(data, null, 2)}</pre>
          </Grid>
        </Grid>
      </Container>
    </Page>
  )
}

export default GIS
